// frontend/src/components/navbar/navTokens.js
//
// The values the app navbar's MUI-styled menus need in JS (sx), kept beside
// pillNav.css so the CSS bar and the JS menus cannot disagree. Plain data: no
// React, no MUI - the tests import it directly.

/** Brand navy (brand/tokens.json `color.navy`). */
export const NAV_INK = "#0E1628";

/** The approved active pill (owner, navy audit round 2): navy at 6%. */
export const NAV_ACTIVE_BG = "rgba(14, 22, 40, 0.06)";

/** Slate - a UI colour for eyebrows and group headings (brand/tokens.json). */
export const NAV_SLATE = "#5E7378";

/** One navy hairline, for separators inside the menus. */
export const NAV_HAIRLINE = "rgba(14, 22, 40, 0.08)";

/**
 * The lockup's rendered height in the bar; pillNav.css drops it to 22 on a
 * phone and 20 at <= 340px (`--lf-pill-lockup-h-phone`).
 */
export const NAV_LOCKUP_HEIGHT = 32;

/**
 * Where the HOMEPAGE pill folds its links into the burger: at or below this
 * width (its CSS repeats the number in homeNav.css). For the app bar it is
 * only the FIRST-RENDER GUESS for an ordinary row of up to six items - the
 * real switch is fit-based (useRowFit.js), measured before the first paint.
 */
export const NAV_MENU_BREAKPOINT_PX = 1080;

/**
 * The app bar's first-render guess for a row of NAV_WIDE_ROW_ITEMS or more
 * (an admin's eight items): below MUI's `lg`. A guess only - see useRowFit.js.
 */
export const NAV_MENU_BREAKPOINT_WIDE_PX = 1199.95;

/** A row with at least this many items uses the wide guess above. */
export const NAV_WIDE_ROW_ITEMS = 7;

/**
 * Below MUI's `md` the app bar is always the burger, whatever fits: tablets in
 * portrait keep the touch menu, as they always have.
 */
export const NAV_ROW_FLOOR_PX = 899.95;

/**
 * The least air the inline row keeps on EACH side of its links - between the
 * brand lockup and the first link, and between the last link and the account
 * pill (review R4 #1: the English row started 8px after what then sat beside
 * the lockup).
 */
export const NAV_ROW_MIN_AIR_PX = 16;

/**
 * How much wider than "just fits" the pill must be before a folded row comes
 * back, so a width at the edge cannot flicker between the two shapes.
 */
export const NAV_ROW_FIT_HYSTERESIS_PX = 16;

/**
 * The account pill shows the name from `lg` up, ellipsed past this width; the
 * full name stays in the menu's header and in the pill's accessible name.
 */
export const NAV_ACCOUNT_NAME_MAX_PX = 120;

/**
 * The admin-tool links. On a PHONE, for an admin, they are grouped under their
 * own heading at the end of the menu's links (owner, navy audit round 4); the
 * desktop bar and the desktop avatar menu are unchanged. For a non-admin
 * customer the same BI / interventions links are their own product features,
 * so they stay in the ordinary list and no heading is drawn.
 */
export const ADMIN_TOOL_PATHS = Object.freeze([
  "/business-intelligence",
  "/interventions/verified",
  "/admin",
]);

/**
 * The phone menu's admin heading. Its id is what each admin row's
 * aria-describedby points at, so a screen reader announces the group name with
 * every row (a MenuList cannot hold a role=group wrapper: it moves focus only
 * across its direct children).
 */
export const ADMIN_GROUP_HEADING_ID = "app-nav-admin-tools-heading";

/**
 * The two features that keep their own icon colour in the menus, so they stay
 * recognisable at a glance (pink BI, teal interventions). Only the icon: the
 * row itself is a plain row with the same navy active pill as every other.
 * "האתר שלי" is deliberately NOT here any more - its gold frame was removed
 * (owner, navy audit round 4: "no marker").
 */
export const SIGNATURE_ICON_COLORS = Object.freeze({
  "/business-intelligence": "#EC4899",
  "/interventions/verified": "#00A896",
});
